import React, { useState, useEffect } from "react";
import styles from "./Dashboard.module.scss";
import { CustomTab } from "src/components";

import globalstyle from "src/assets/scss/global.module.scss";
import { BackButton } from "src/components";
import { Title } from "src/constants/constVariables";
import { useNavigate } from "react-router-dom";
import dashboardImg from 'src/assets/images/dashboardImg.PNG';
import { baseApiCall } from "src/api/Api";
import { dashboard_all_endpoints } from "src/constants/url";
import moment from "moment";
import { commonVaribles } from "src/constants/constVariables";
import { Loader } from "src/components";
import { useDispatch } from "react-redux";
import { filterDates } from "src/redux/features";
import { conversionToCrore } from "src/constants/utils";

const Sequence = ["CV Jamshedpur", "CV Pune", "CV Pantnagar", "CV Lucknow", "CV Dharwad"];
export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [kpiData, setKpiData] = useState([]);
  const [data, setData] = useState([]);
  const today = new Date();
  const lastYear = new Date(today);
  lastYear.setFullYear(lastYear.getFullYear() - 1);
  lastYear.setMonth(3); // March is 2 in JavaScript Date object
  lastYear.setDate(1); // Last day of March of last year
  const currentMonth = today.getMonth();
  let startDateDashboard;
  if (currentMonth < 3) {
    startDateDashboard = moment(lastYear);
  } else {
    startDateDashboard = moment(today.getFullYear(), "YYYY")
      .month(3)
      .date(1) 
  }
  const [startDate, setStartDate] = useState(startDateDashboard);
  const [endDate, setEndDate] = useState(moment(new Date()).endOf('day').utc().format());
  // dispatch(filterDates([startDate, endDate]));
  
  useEffect(() => {
    DashboardData();
  }, [startDate, endDate]);

  const DashboardData = () => { 
    baseApiCall({
      url: dashboard_all_endpoints.GET_PLANT_WISE_SUMMARY_DATA_FOR_DASHBOARD,
      requestBody: {
        start_date: startDate,
        end_date: endDate,
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        setLoader(false);
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setKpiData(data.kpi_data);
          data?.plant_wise_data.sort((a, b) => {
            const indexA = Sequence.indexOf(a.plant_name);
            const indexB = Sequence.indexOf(b.plant_name);
            if (indexA !== -1 && indexB !== -1) {
                return indexA - indexB;
            }
            if (indexA === -1) {
                return 1;
            }
            if (indexB === -1) {
                return -1;
            }
        });
          setData(data.plant_wise_data);
          setLoader(true);
        } else {
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const dateSetter = (newStartDate, newEndDate) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  async function dateClearFilter() {
		setStartDate(new Date(startDateDashboard));
		setEndDate(moment(new Date()).endOf('day').utc().format());

		return {
			defaultStartDate: new Date(startDateDashboard),
			defaultEndDate: moment(new Date()).endOf('day').utc().format(),
		};
  };

  return (
    <div>
      <div className={globalstyle.breadcrumb}>
        <BackButton
          basePath={Title.home}
          action={Title.dashboard}
          handleClick={() => {
            navigate("/");
          }}
          browserBack={true}
        />
      </div>
      {loader ? (
        <div className={styles["customTabDashPage"]}>
          <CustomTab
            title={Title.dashboard}
            count={0}
            withOutCount={true}
            searchQuery={null}
            isSearchBar={false}
            setSearchQuery={() => {}}
            isDatepicker={true}
            isDropdown={false}
            isSelected={false}
            isCheckbox={false}
            onChangeDatefilter={dateSetter}
            searchValueFetch={() => {}}
            dateClearFilter={dateClearFilter}
            startDate={startDate}
            endDate={endDate}
          />
          <div className={styles["customeDashDiv"]}>
            <div className={styles["child"]}>
              <div className={styles["child2"]}>
                <div className={styles["topHeading"]}>
                  Packaging Logistics <br /> Sheets
                </div>
                <div className={styles["subHeading"]}>
                  {kpiData?.packaging_logistics_sheets}
                </div>
              </div>
            </div>
            <div className={styles["child"]}>
              <div className={styles["child2"]}>
                <div className={styles["topHeading"]}>APV</div>
                <div className={styles["subHeading"]}>{kpiData?.apv} Cr</div>
              </div>
            </div>
            <div className={styles["child"]}>
              <div className={styles["child2"]}>
                <div className={styles["topHeading"]}>Supplier</div>

                <div className={styles["subHeading"]}>
                  {kpiData?.supplier_count}
                </div>
              </div>
            </div>
            <div className={styles["child"]}>
              <div className={styles["child2"]}>
                <div className={styles["topHeading"]}>Parts</div>
                <div className={styles["subHeading"]}>
                  {kpiData?.parts_count}
                </div>
              </div>
            </div>
            <div className={styles["child"]}>
              <div className={styles["child2"]}>
                <div className={styles["topHeading"]}>
                  Logistics cost inclusive in <br /> part cost nos.
                </div>
                <div className={styles["subHeading"]}>
                  {kpiData?.logistics_cost_inclusive_in_part_cost_nos} ({" "}
                  {kpiData?.logistics_cost_inclusive_in_part_cost_nos_perc} % )
                </div>
              </div>
            </div>

            <div className={styles["child"]}>
              <div className={styles["child2"]}>
                <div className={styles["topHeading"]}>
                  Returnable
                  <br /> Recommendations
                </div>
                <div className={styles["subHeading"]}>
                  {kpiData?.returnable_recommendations_perc} %
                </div>
              </div>
            </div>
          </div>

          <div className={styles["customeDashDiv2"]}>
            {data.map((item, index) => (
              <>
                <div key={index} className={styles["sheet-recommendation"]}>
                  <div className={styles["inner-title-container"]}>
                    <div className={styles["inner-title"]}>
                      {item.plant_name}
                    </div>
                  </div>
                  <div className={styles["innerSub_container"]}>
                    <div className={styles["inner-subtitle"]}>
                      <div className={styles["inner-subtitile-heading"]}>
                        Total recommended sheets
                      </div>
                    </div>
                    <div className={styles["inner-title-value"]}>
                      <p>{item.summary_data.total_recommended_sheets}</p>
                    </div>
                  </div>
                  <div className={styles["innerSub_container"]}>
                    <div className={styles["inner-subtitle"]}>
                      <div className={styles["inner-subtitile-heading"]}>
                        Returnable Strategy
                      </div>
                    </div>
                    <div className={styles["inner-title-value"]}>
                      <p>{item.summary_data.returnable_strategy}</p>
                    </div>
                  </div>

                  <div className={styles["innerSub_container"]}>
                    <div className={styles["inner-subtitle"]}>
                      <div className={styles["inner-subtitile-heading"]}>
                        Total Cost ₹
                      </div>
                    </div>
                    <div className={styles["inner-title-value"]}>
                      <p>{item.summary_data.total_cost}</p>
                    </div>
                  </div>
                  {/* <p>Returnable Strategy: {item.returnableSheets} ({item.returnablePercentage})</p> */}
                </div>
                {index === 0 && (
                  <div className={styles["logo"]}>
                    <img
                      src={dashboardImg}
                      alt="Dashboard"
                      className={styles["image_logo"]}
                    />
                  </div>
                )}
              </>
            ))}
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
}
